import axios from "axios";
import { IAxiosReturn } from "./interface";
import { processAxiosError } from "./processAxiosError";

export type IBackEndVersionReturn = IAxiosReturn<string>;

/**
 * Gets the back end version
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @param _ - Unused parameter for consistency with loader signature
 * @param controller - Optional AbortController for cancelling the request
 * @returns Promise<IBackEndVersionReturn>
 */
export const getBackEndVersion = async (
  backEndUrl: string,
  _?: string,
  controller?: AbortController,
): Promise<IBackEndVersionReturn> => {
  const url = `${backEndUrl}Version`;
  // Get data
  try {
    const response: { data: { backendVersion: string; azPdfWrapperVersion: string } } =
      await axios.get(url, controller !== undefined ? { signal: controller.signal } : undefined);
    // Return successful result
    return {
      success: true,
      data: `mbbe ${response.data.backendVersion}`,
    };
  } catch (error: unknown) {
    return processAxiosError("Load back end version failed", error);
  }
};
